/**
 * Das Suchfeld des Zeitstrahls - 1:1-Portierung von `index.html:13759-13768`.
 *
 * Der Loeschknopf erscheint im Original NUR bei nicht leerer Suche (`${timelineSearch ? ... : ''}`,
 * index.html:13766) - woertlich uebernommen.
 *
 * NICHT uebernommen: `setTimelineSearch` (index.html:13722-13729) setzt den Fokus nach dem
 * Neuzeichnen ueber ein `setTimeout` zurueck ins Feld und stellt die Schreibmarke ans Ende. Das ist
 * eine Reparatur an einem Problem, das nur die Zeichenkettenrekonstruktion des Bestands hat: dort
 * ersetzt jeder Tastendruck `page.innerHTML` und zerstoert dabei das fokussierte Eingabefeld. React
 * behaelt den Knoten; ein nachgebauter Fokusgriff wuerde hier nichts richten, sondern den Fokus
 * gegen den Willen des Benutzers festhalten. Gemeldet im Task-Bericht, nicht nachgebaut.
 *
 * Task 6 (Verdrahtungsplan Phase 6): die beiden `<i data-lucide>`-Platzhalter (`search`/`x`) sind auf
 * `Ikone` umgestellt - in der SPA hydriert sie niemand (die UMD-Fassung von lucide laeuft ausschliesslich
 * im Playwright-Baseline-Rundlauf, `harness.ts:218`), sie blieben bislang leere 18x18-Flaechen.
 */
import { Ikone } from "../Ikone.tsx";

export interface ZeitstrahlSucheProps {
  wert: string;
  onAendern: (wert: string) => void;
}

export function ZeitstrahlSuche({ wert, onAendern }: ZeitstrahlSucheProps) {
  return (
    <div className="tlp-search">
      <label htmlFor="timelineSearch">Suche</label>
      <div className="tlp-search-field">
        <Ikone name="search" />
        <input
          id="timelineSearch"
          type="search"
          value={wert}
          placeholder="Rechnung, Sendung, Bestellung, Artikel oder Lieferant"
          aria-label="Zeitstrahl durchsuchen"
          onChange={(ereignis) => onAendern(ereignis.target.value)}
        />
        {wert ? (
          <button
            className="tlp-search-clear"
            type="button"
            onClick={() => onAendern("")}
            aria-label="Suche löschen"
            title="Suche löschen"
          >
            <Ikone name="x" />
          </button>
        ) : null}
      </div>
    </div>
  );
}
